var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSingle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 38,
    viewBox: "0 0 32 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6032 0.216797L-0.000152588 27.2386H31.2023L15.6032 0.216797Z",
    fill: "#5DB7E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6034 9.23828L7.93679 22.5176H23.27L15.6034 9.23828Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2351 22.3682V27.2734H21.0318V22.3682H10.2351Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1849 19.8721H10.2135V35.4411H13.1849V19.8721Z",
    fill: "#0C4480"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1682 23.8213H14.1968V37.7824H17.1682V23.8213Z",
    fill: "#0C4480"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0444 19.8682H18.0729V35.4372H21.0444V19.8682Z",
    fill: "#0C4480"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSingle);
export default __webpack_public_path__ + "static/media/logo-single.1fe06c0e4eaa39a105dd46f69afb9d9e.svg";
export { ForwardRef as ReactComponent };